import { Badge } from "@/components/ui/badge";
import { formatCampaignStatus, formatDate } from "components/helpers";
import {
  CustomFieldsPanelSection,
  PanelField,
  PanelSection,
} from "components/sidebar/sections/InfoPanel";
import CONSTANTS from "constants/Constants";

const STATUS_VARIANTS = {
  [CONSTANTS.CAMPAIGN_STATUS_TYPES.ACTIVE]: "success",
  [CONSTANTS.CAMPAIGN_STATUS_TYPES.INACTIVE]: "secondary",
  [CONSTANTS.CAMPAIGN_STATUS_TYPES.ARCHIVED]: "outline",
};

// Read-only information for the campaign detail rail; controls live in the header.
const CampaignInfoPanel = ({ campaign, isLoading = false }) => {
  const custom = campaign?.custom_fields;
  const metrics = campaign?.metrics ?? {};

  return (
    <>
      <PanelSection isLoading={isLoading}>
        <PanelField label="Status" inline>
          {campaign?.status == null ? null : (
            <Badge variant={STATUS_VARIANTS[campaign.status] ?? "outline"}>
              {formatCampaignStatus(campaign.status)}
            </Badge>
          )}
        </PanelField>
        <PanelField label="Description">
          {campaign?.info?.description}
        </PanelField>
        <PanelField label="Email URL">{campaign?.form_name}</PanelField>
        <PanelField label="Region">{campaign?.region_name}</PanelField>
        <PanelField label="Assignee">
          {campaign?.assigned_user_full_name}
        </PanelField>
        <PanelField label="Creator">
          {campaign?.creator_user_full_name}
        </PanelField>
      </PanelSection>

      <PanelSection title="Timeframe" isLoading={isLoading}>
        <PanelField label="Start">
          {formatDate(campaign?.start_time)}
        </PanelField>
        <PanelField label="End">{formatDate(campaign?.end_time)}</PanelField>
        <PanelField label="Created at">
          {formatDate(campaign?.created_at)}
        </PanelField>
      </PanelSection>

      <PanelSection title="Metrics" isLoading={isLoading}>
        <PanelField label="Entities">{metrics.entity_count}</PanelField>
        <PanelField label="Contacts">{metrics.contact_count}</PanelField>
        <PanelField label="Emailable Contacts">
          {metrics.emailable_contact_count}
        </PanelField>
        <PanelField label="Callable Contacts">
          {metrics.callable_contact_count}
        </PanelField>
      </PanelSection>

      <CustomFieldsPanelSection
        title="Custom Fields"
        items={custom}
        modelType="Campaign"
        isLoading={isLoading}
      />
    </>
  );
};

export default CampaignInfoPanel;
